import { Heading } from '@moonpig/launchpad-components'

export const TemplateSettingsControls = () => (
  <Heading level="h4" margin="16px" />
)
